import { ChangeEvent, FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Hooks
import useToggle from 'app/hooks/useToggle';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectCalendarEventsParams } from 'app/store/CalendarEvents/CalendarEventsSelectors';
import { selectCalendarEventTypes } from 'app/store/CalendarEventTypes/CalendarEventTypesSelectors';
// MUI
import { Box, Tooltip, Typography } from '@mui/material';
// Icons
import { Add as AddIcon } from '@mui/icons-material';
// Components
import { IconButton } from 'app/components/Mui';
import EventTypesForm from './EventTypesForm';
import EventTypeItem from './EventTypeItem';

type Props = {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const CalendarEventTypes:FC<Props> = ({ onChange }) => {
  const { t } = useTranslation();

  const eventTypes = useAppSelector(selectCalendarEventTypes);
  const params = useAppSelector(selectCalendarEventsParams);

  const { open, toggle } = useToggle();

  return (
    <Fragment>
      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, pr: 2 }}>
          <Typography>{t('labels.eventTypes')}</Typography>
          <Tooltip title={t('pages.companyCalendar.createEventTypeButton')}>
            <IconButton
              name={'create-event-type'}
              size="small"
              onClick={toggle}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={{
          maxHeight: '170px',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}>
          {eventTypes?.map((type) => (
            <EventTypeItem key={type.id} eventType={type} checked={params.typeIds.includes(Number(type.id))} onChange={onChange} />
          ))}
        </Box>
      </Box>

      {open ? (
        <EventTypesForm open={open} onClose={toggle} />
      ) : null}
    </Fragment>
  )
}

export default CalendarEventTypes;
